import React, { useState } from "react";
import {
  BodyText,
  DisplayBetween,
  DisplayCenter,
  DisplayStart,
  FormControl,
  HelpContentModal,
  HelpDividerGray,
  HelpModalLanguageBox,
  HelpModalLanguageText,
  HelpModalTitle,
  InputText,
  LanguageBtn,
  SelectLanguageWrapper,
} from "../StyledComponents";
import FormLabel from "@mui/joy/FormLabel";
import Radio, { radioClasses } from "@mui/joy/Radio";
import RadioGroup from "@mui/joy/RadioGroup";
import Sheet from "@mui/joy/Sheet";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import LoadingButton from "@mui/lab/LoadingButton";
import axios from "axios";
import { URLs } from "../../utils/urls";
import { addTextToCanvas } from "../../utils/helpers";
import { useSelector } from "react-redux";

const HelpModalContent = () => {
  const { canvas } = useSelector((state) => state.canvas);
  const [btnLoading, setBtnLoading] = useState(false);
  const [selectedValue, setSelectedValue] = useState("English");
  const [formState, setFormState] = useState({});

  const handleChangeLanguage = (event) => {
    setSelectedValue(event.target.value);
  };

  const handleChange = (name, value) => {
    setFormState({
      ...formState,
      [name]: value,
    });
  };

  const askSally = () => {
    setBtnLoading(true);
    let sallyData = formState;
    sallyData["lang"] = selectedValue;
    console.log(sallyData);
    const token = sessionStorage.getItem("auth_token");
    axios
      .post(URLs.ASK_SALLY, sallyData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("Data saved successfully:", response.data);
        addTextToCanvas(response.data.Output, 14, false, canvas, true);
        setBtnLoading(false);
      })
      .catch((error) => {
        setBtnLoading(false);
      });
  };

  return (
    <>
      <DisplayCenter>
        <HelpModalTitle>AI writer</HelpModalTitle>
      </DisplayCenter>
      <HelpContentModal>
        <BodyText>
          Our deepest condolences for your loss, let us help you with putting
          into words what you will like to express to your loved one.
        </BodyText>
        <HelpModalLanguageBox>
          <SelectLanguageWrapper>
            <HelpModalLanguageText>
              Please select your desire language
            </HelpModalLanguageText>
            <RadioGroup
              aria-label="platform"
              defaultValue="English"
              overlay
              name="platform"
              onChange={handleChangeLanguage}
              value={selectedValue}
              sx={{
                flexDirection: "row",
                gap: 3,
                [`& .${radioClasses.checked}`]: {
                  [`& .${radioClasses.action}`]: {
                    inset: -1,
                    border: "2px solid",
                    borderColor: "primary.500",
                  },
                },
                [`& .${radioClasses.radio}`]: {
                  display: "contents",
                  "& > svg": {
                    zIndex: 2,
                    position: "absolute",
                    top: "-6px",
                    right: "-6px",
                    bgcolor: "background.body",
                    borderRadius: "50%",
                    height: 16,
                    width: 16,
                  },
                },
              }}
            >
              {["English", "Espanol", "Franqais"].map((value) => (
                <Sheet
                  key={value}
                  variant="outlined"
                  sx={{
                    borderRadius: "md",
                    bgcolor: "background.body",
                    height: 20,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    boxShadow: "sm",
                    p: 0.8,
                    minWidth: 25,
                  }}
                >
                  <Radio
                    id={value}
                    value={value}
                    checkedIcon={<CheckCircleRoundedIcon />}
                  />
                  <FormLabel htmlFor={value}>{value}</FormLabel>
                </Sheet>
              ))}
            </RadioGroup>
          </SelectLanguageWrapper>
        </HelpModalLanguageBox>
        <HelpDividerGray />
        <BodyText className="fs-12px">
          Next, please answer this next questions. It's 0k if you skip a
          question or two! Just keep in mind the more info you provide to Sally,
          the better she will work!
        </BodyText>
        <HelpDividerGray />
        <FormControl>
          <BodyText>Name of your loved one</BodyText>
          <DisplayStart>
            <InputText
              type="text"
              placeholder="Here the name of the loved one"
              value={formState["Person_Detail"] || ""}
              onChange={(e) => handleChange("Person_Detail", e.target.value)}
            />
          </DisplayStart>
        </FormControl>
        <FormControl>
          <BodyText>Date of Birth</BodyText>
          <DisplayStart>
            <InputText
              type="date"
              placeholder="Date"
              value={formState["Date_of_birth"] || ""}
              onChange={(e) => handleChange("Date_of_birth", e.target.value)}
            />
          </DisplayStart>
        </FormControl>
        <FormControl>
          <BodyText>Age of passing</BodyText>
          <DisplayStart>
            <InputText
              type="number"
              placeholder="Age"
              value={formState["Age_of_passing"] || ""}
              onChange={(e) => handleChange("Age_of_passing", e.target.value)}
            />
          </DisplayStart>
        </FormControl>
        <FormControl>
          <BodyText>Place of Birth</BodyText>
          <DisplayStart>
            <InputText
              type="text"
              placeholder="Place of birth"
              value={formState["Place_of_birth"] || ""}
              onChange={(e) => handleChange("Place_of_birth", e.target.value)}
            />
          </DisplayStart>
        </FormControl>
        <FormControl>
          <BodyText>Name of Parents</BodyText>
          <DisplayStart>
            <InputText
              type="text"
              placeholder="Parents Name"
              value={formState["Names_of_parents"] || ""}
              onChange={(e) => handleChange("Names_of_parents", e.target.value)}
            />
          </DisplayStart>
        </FormControl>
        <FormControl>
          <BodyText>Grew up in (city and state)</BodyText>
          <DisplayStart>
            <InputText
              type="text"
              placeholder="Grew up city"
              value={formState["Grew_up_in"] || ""}
              onChange={(e) => handleChange("Grew_up_in", e.target.value)}
            />
          </DisplayStart>
        </FormControl>
        <FormControl>
          <BodyText>Children Name</BodyText>
          <DisplayStart>
            <InputText
              type="text"
              placeholder="Children"
              value={formState["Children_Name"] || ""}
              onChange={(e) => handleChange("Children_Name", e.target.value)}
            />
          </DisplayStart>
        </FormControl>
        <FormControl>
          <BodyText>Schools attended</BodyText>
          <DisplayStart>
            <InputText
              type="text"
              placeholder="School"
              value={formState["School_Attended"] || ""}
              onChange={(e) => handleChange("School_Attended", e.target.value)}
            />
          </DisplayStart>
        </FormControl>
        <FormControl>
          <BodyText>Employment</BodyText>
          <DisplayStart>
            <InputText
              type="text"
              placeholder="Employment"
              value={formState["Employment"] || ""}
              onChange={(e) => handleChange("Employment", e.target.value)}
            />
          </DisplayStart>
        </FormControl>
        <FormControl>
          <BodyText>Hobbies or interest</BodyText>
          <DisplayStart>
            <InputText
              type="text"
              placeholder="Hobbies"
              value={formState["Hobbies_and_interest"] || ""}
              onChange={(e) =>
                handleChange("Hobbies_and_interest", e.target.value)
              }
            />
          </DisplayStart>
        </FormControl>
        <FormControl>
          <BodyText>Religion or beliefs</BodyText>
          <DisplayStart>
            <InputText
              type="text"
              placeholder="Religion"
              value={formState["Religion_or_beliefs"] || ""}
              onChange={(e) =>
                handleChange("Religion_or_beliefs", e.target.value)
              }
            />
          </DisplayStart>
        </FormControl>
        <FormControl>
          <BodyText>Awards or special recognition</BodyText>
          <DisplayStart>
            <InputText
              type="text"
              placeholder="Awards"
              value={formState["Awards"] || ""}
              onChange={(e) => handleChange("Awards", e.target.value)}
            />
          </DisplayStart>
        </FormControl>
        <FormControl>
          <BodyText>Special moments him/her</BodyText>
          <DisplayStart>
            <InputText
              type="text"
              placeholder="Special moments"
              value={formState["Special_moments"] || ""}
              onChange={(e) => handleChange("Special_moments", e.target.value)}
            />
          </DisplayStart>
        </FormControl>
        <FormControl>
          <BodyText>Words that describe him or her</BodyText>
          <DisplayStart>
            <InputText
              type="text"
              placeholder="Describe him or her"
              value={formState["Personality_Traits"] || ""}
              onChange={(e) =>
                handleChange("Personality_Traits", e.target.value)
              }
            />
          </DisplayStart>
        </FormControl>
        <FormControl>
          <BodyText>Survived by</BodyText>
          <DisplayStart>
            <InputText
              type="text"
              placeholder="Survived by"
              value={formState["Survived_by"] || ""}
              onChange={(e) => handleChange("Survived_by", e.target.value)}
            />
          </DisplayStart>
        </FormControl>
        <LoadingButton
          onClick={askSally}
          loading={btnLoading}
          loadingPosition="end"
          endIcon={<PublishedWithChangesIcon />}
          variant="contained"
        >
          <span>Create Orbituary</span>
        </LoadingButton>
      </HelpContentModal>
    </>
  );
};

export default HelpModalContent;
